<template>
  <div class="home">
    <div class="banner-wrap">
			<!-- <img src="../../assets/images/banner.jpg" alt=""> -->
      <img src="http://ylxh-service.oss-cn-hangzhou.aliyuncs.com/banner.jpg" alt="">      
      <!-- <Swiper :opts="swiperOpts">
        <template>
          <div class="swiper-slide">
            <img src="../../assets/images/banner.png" alt="" />
          </div>
          <div class="swiper-slide">
            <img src="../../assets/images/banner.png" alt="" />
          </div>
          <div class="swiper-slide">
            <img src="../../assets/images/banner.png" alt="" />
          </div>
        </template>
        <template slot="other">
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </template>
      </Swiper> -->
      <div class="notice-wrap">
        <div class="notice-header">
          <img src="../../assets/images/notice.png" alt="">
          <span class="notice-title">通知公告</span>
          <span class="notice-more" @click="linkTo('/notice')">更多》</span>
        </div>
        <div class="notice-content">
          <div class="notice-item" v-for="(n, index) in noticeList" :key="index" @click="toNoticeDetail(n)">
            <div class="notice-item-text">{{n.title}}</div>
            <div class="notice-time">{{n._date}}</div>
          </div>
        </div>
      </div>
    </div>
    <News :news-list="newsList" :mem-list="memList" />
    <Award :activityData="activityData" :awardList="awardList" />
    <Institute />
    <!-- <Activity :activityData="activityData" />
    <Engineering :list="awardList" /> -->
    <Policy v-if="policyList.length" :list="policyList" />
    <Journal :list="publishList" />
    <Tourist /> 
    <City />
    <!-- <Member /> -->
  </div>
</template>

<script>
import moment from 'moment';
import router from '@/router';
import Swiper from '@/components/Swiper';
import News from './News.vue';
import Award from './Award.vue';
import Policy from './Policy.vue';
import Journal from './Journal.vue';
import Tourist from './Tourist.vue';
import City from './City.vue';
import Member from './Member.vue';
import Institute from './Institute.vue';
import { getHomeData, getTopNoticeList, getHomeArticle } from './service/api';

export default {
  data() {
    return {
      noticeList: [],
      activityData: {},
      swiperOpts: {
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next'
        }
      },
      awardList: [],
      newsList: [],
      memList: [],
      policyList: [],
      publishList: []
    }
  },
  components: {
    Swiper,
    News,
    Award,
    Policy,
    Journal,
    Tourist,
    City,
    Member,
    Institute
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getHomeData();
      this.getTopList();
      this.getHomeArticle();
    },
    getHomeData() {
      getHomeData().then(res => {
        this.setActivityData(res);
        this.awardList = (res.award || []).map(item => {
          item._releaseTime = moment(item.releaseDate * 1000).format('YYYY-MM-DD')
          return item;
        });
      });
    },
    getTopList() {
      getTopNoticeList().then(res => {
        this.noticeList = (res || []).map(item => {
          item._date = moment(item.releaseDate*1000).format('YYYY/MM/DD');
          return item;
        });
      })
    },
    setActivityData(res) {
      this.activityData = ['activity', 'meeting', 'salon'].reduce((obj, key) => {
        obj[key] = (res[key] || []).map(item => {
          item._date = moment(item.releaseDate*1000).format('YYYY/MM/DD');
          item._rangeTime = `${moment(item.actStartDate*1000).format('YYYY/MM/DD')}~${moment(item.actEndDate*1000).format('YYYY/MM/DD')}`
          return item;
        });
        return obj;
      }, {});
    },
    getHomeArticle() {
      getHomeArticle().then(res => {
        this.newsList = (res.xhxw || []).map(item => {
          const date = moment(item.releaseDate*1000);
          item._releaseDate = date.format('YYYY/MM/DD');
          item._md = date.format('MM-DD');
          item._year = date.format('YYYY');
          return item;
        });
        this.memList = (res.xhdt || []).map(item => {
          const date = moment(item.releaseDate*1000);
          item._releaseDate = date.format('YYYY/MM/DD');
          item._md = date.format('MM-DD');
          item._year = date.format('YYYY');
          return item;
        });
        this.policyList = (res.zcfg || []).map(item => {
          const date = moment(item.releaseDate*1000);
          item._releaseDate = date.format('YYYY/MM/DD');
          return item;
        });
        this.publishList = res.bjcb || [];
      })
    },
    linkTo(uri) {
      router.push(uri);
    },
    toNoticeDetail(item) {
      this.linkTo(`/notice/detail?aId=${item.id}`);
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/less/global.less';

.banner-wrap {
  position: relative;
  min-width: @middleWidth;
  height: 50vw;
  min-height: @middleWidth/2;
  
  > img {
	  width: 100%;
		height: 100%;
		display: block;
  }
  
  .notice-wrap {
    width: 430px;
    height: 70%;
    position: absolute;
    right: 100px;
    bottom: 9%;
    z-index: 1;
    background: rgba(0, 0, 0, .5);
    border-radius:5px;
    display: flex;
    flex-direction: column;
    cursor: default;

    .notice-header {
      padding: 30px 13px 10px;
      display: flex;
      align-items: center;

      > img {
        width: 24px;
        height: 20px;
        margin-right: 6px;
      }

      .notice-title {
        font-size: 20px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 600;
        color: #FFFFFF;
      }

      .notice-more {
        margin-left: auto;
        font-size: 13px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #FFFFFF;
        cursor: pointer;
      }
    }

    .notice-content {
      flex: 1;
      overflow: hidden;
      overflow-y: auto;

      .notice-item {
        width: 100%;
        padding: 10px 23px 15px 39px;
        font-size: 16px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 22px;
        position: relative;
        display: flex;
        cursor: pointer;

        &:hover {
          background: url(../../assets/images/notice-active.png) no-repeat center center;
          background-size: 100% 100%;
        }

        &::before, &::after {
          content: '';
          position: absolute;
          left: 20px;
        }

        &:first-child {
          overflow: hidden;

          &::before {
            top: 12px;
          }
        }

        &::before {
          top: 0;
          width: 2px;
          height: 100%;
          opacity: 0.5;
          background: #F3F3F3;
          transform: translateX(-1px);
        }

        &::after {
          width: 4px;
          height: 4px;
          top: 10px;
          transform: translateX(-50%);
          background: #46647A;
          border: 4px solid #FFFFFF;
          border-radius: 50%;
        }

        .notice-item-text {
          width: 280px;
          word-break: break-all;
        }

        .notice-time {
          // padding-top: 10px;
          margin-left: auto;
          font-size: 12px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 18px;
        }
      }
    }
  }
}

</style>